export const PERFORMANCE_NAVIGATION_TIMING_SCHEMA = 'iglu:org.w3/PerformanceNavigationTiming/jsonschema/1-0-0';



// WEBPACK FOOTER //
// ../src/schemata.ts